import { Box } from '@material-ui/core';
import React from 'react';

import { Font } from '@/components/shared/components/Font';
import { NemuruDialog, NemuruDialogProps } from '@/components/shared/components/NemuruDialog';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';

interface ActionDialogProps extends Omit<NemuruDialogProps, 'children'> {
  opened: boolean;
  setOpened: (opened: boolean) => void;
  handleClose: () => void;
  Title: JSX.Element;
  onSubmit?: () => void;
  Description?: JSX.Element;
  MainButton?: JSX.Element;
  CloseButton?: JSX.Element;
  hideMainButton?: boolean;
  loading?: boolean;
  disabled?: boolean;
  children?: React.ReactNode;
}

export const ActionDialog = ({
  opened,
  setOpened,
  handleClose,
  Title,
  Description,
  MainButton,
  CloseButton,
  onSubmit,
  loading = false,
  disabled = false,
  hideMainButton = false,
  children,
  ...props
}: ActionDialogProps) => {
  return (
    <NemuruDialog
      avoidDefaultClose
      opened={opened}
      setOpened={setOpened}
      buttons={
        <>
          {props.avoidDefaultClose !== false && (
            <StandardButton disabled={loading} onClick={handleClose}>
              {CloseButton ? CloseButton : <Text tId={'CANCEL'} />}
            </StandardButton>
          )}
          {!hideMainButton && !!onSubmit && (
            <StandardButton main disabled={disabled ?? loading} loading={loading} onClick={onSubmit}>
              {MainButton ? MainButton : <Text tId={'SAVE'} />}
            </StandardButton>
          )}
        </>
      }
      {...props}
    >
      <Box mb={4}>
        <Font variant={'h3'} color={'title'}>
          {Title}
        </Font>
      </Box>
      {Description && (
        <Box mb={2}>
          <Font variant={'body2'} color={'textPrimary'}>
            {Description}
          </Font>
        </Box>
      )}
      {children}
    </NemuruDialog>
  );
};
